import { gql } from 'apollo-angular';

export const MUTATION_CREATE_WARRANTY_CERTIFICATE_FOR_EQUIPMENT = gql`
  mutation createWarrantyCertificateForEquipment(
    $input: UpsertWarrantyCertificateDto!
    $equipmentId: String!
  ) {
    createWarrantyCertificateForEquipment(
      input: $input
      equipmentId: $equipmentId
    ) {
      id
      name
      status
    }
  }
`;
